import React, { useMemo } from 'react';

const BLOB_KEYFRAMES = [
    '60% 40% 30% 70% / 60% 30% 70% 40%',
    '30% 60% 70% 40% / 50% 60% 30% 60%',
    '50% 50% 40% 60% / 40% 60% 50% 50%',
    '40% 60% 60% 40% / 60% 40% 60% 40%',
    '60% 40% 30% 70% / 60% 30% 70% 40%',
];

export default function MorphingGradientOrb({ amplitude = 0, isSpeaking, isThinking, size = 64 }) {
    const scale = 1 + amplitude * 0.18;
    const speed = isThinking ? '2s' : isSpeaking ? '1.5s' : '4s';
    const glowSize = 6 + amplitude * 24;
    const rotationSpeed = isThinking ? '3s' : '8s';

    const gradientAngle = useMemo(() => Math.floor(Math.random() * 360), []);

    return (
        <div className="relative" style={{ width: size, height: size }}>
            {/* Glow layer */}
            <div
                className="absolute inset-0 rounded-full blur-md"
                style={{
                    background: `linear-gradient(${gradientAngle}deg, #8b5cf6, #a855f7, #7c3aed)`,
                    opacity: 0.3 + amplitude * 0.4,
                    transform: `scale(${1.2 + amplitude * 0.3})`,
                    transition: 'opacity 0.15s, transform 0.15s',
                }}
            />
            {/* Morphing blob */}
            <div
                style={{
                    width: size,
                    height: size,
                    borderRadius: BLOB_KEYFRAMES[0],
                    background: `linear-gradient(${gradientAngle}deg, #c4b5fd, #8b5cf6, #6d28d9, #7c3aed)`,
                    backgroundSize: '300% 300%',
                    animation: `morphBlob ${speed} ease-in-out infinite, gradientShift ${rotationSpeed} linear infinite`,
                    transform: `scale(${scale})`,
                    transition: 'transform 0.1s ease-out',
                    boxShadow: `0 0 ${glowSize}px rgba(139, 92, 246, ${0.2 + amplitude * 0.3})`,
                }}
            />
            {/* Center highlight */}
            <div
                className="absolute rounded-full pointer-events-none"
                style={{
                    top: '20%', left: '25%', width: '35%', height: '30%',
                    background: 'radial-gradient(ellipse, rgba(255,255,255,0.4), transparent)',
                    filter: 'blur(2px)',
                }}
            />
        </div>
    );
}
